import { ButtonV3, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import { EventType } from '@/analytics/types';
import Motion from '@/app/components/Motion';
import SectionHeading from '@/app/components/SectionHeading';

export interface PopCompareModelsContentProps {
  readonly copy: MessageKey;
  readonly onCtaClick: () => void;
  readonly title: MessageKey;
}

const PopCompareModelsContent = ({
  copy,
  onCtaClick,
  title,
}: PopCompareModelsContentProps) => {
  const t = useTranslations();

  const UPGRADE_FAQ_LINK = t('upgrade_faq_link');

  const onUpgradeFaqClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'read_more',
      location: 'POP Compare Upgrade FAQ Button',
      path: UPGRADE_FAQ_LINK,
    });
  };

  return (
    <div className="flex h-full flex-col justify-center">
      <SectionHeading
        animated
        className="mb-6"
        content={title}
        typographyProps={{
          className: 'leading-tighter text-current font-normal',
          Element: 'h2',
          variant: 'h4',
        }}
      />
      <Motion
        initial={{ opacity: 0 }}
        transition={{ delay: 0.35, duration: 0.75, type: 'tween' }}
        viewport={{ once: true }}
        whileInView={{ opacity: 1 }}
      >
        <TypographyV3 className="mb-6">{t(copy)}</TypographyV3>
        <div className="flex flex-col flex-wrap gap-2 xl:flex-row">
          <ButtonV3
            data-cy="pop-compare-models-cta"
            onClick={onCtaClick}
            variant="secondary-dark"
          >
            <span className="text-nowrap">{t('compare_oura_ring_models')}</span>
          </ButtonV3>
          <ButtonV3
            className="border-2 font-bold text-nowrap hover:border-gray-600 hover:text-gray-600"
            data-cy="pop-upgrade-faq-cta"
            href={UPGRADE_FAQ_LINK}
            onClick={onUpgradeFaqClick}
            target="_blank"
            variant="outlined-dark"
          >
            {t('upgrade_faq')}
          </ButtonV3>
        </div>
      </Motion>
    </div>
  );
};

export default PopCompareModelsContent;
